import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import Popover from '@liveauctioneers/caterwaul-components/lib/Popover/Popover';
import React from 'react';
import styled from 'styled-components';
import styles from './WhatIsCountdownPopover.module.scss';

type Props = {};

const WhatIsCountdownPopover = () => {
    const popover = (
        <div id="what-is-this-countdown">
            <FormattedMessage id="itemBidding.dontWait" />
        </div>
    );
    const whatIsCountdownOverlay = (
        <StyledPopover click placement="left" trigger={<FontAwesomeIcon className={styles.icon} icon={faInfoCircle} />}>
            <>{popover}</>
        </StyledPopover>
    );
    return whatIsCountdownOverlay;
};

export default React.memo<Props>(WhatIsCountdownPopover);

const StyledPopover = styled(Popover)`
    width: 256px;
    padding: 5px;
`;
